export const newsContent = [
    {
      id: 13,
      title: "Catalina Velásquez representará al colegio en la etapa final de las Olimpiadas de Matemática 2026",
      date: "2026-10-14",
      content: `Nuestra comunidad escolar celebra el destacado desempeño de los estudiantes que participaron en las Olimpiadas de Matemática 2026. Tras las etapas de selección, la estudiante de 3° Medio Catalina Velásquez Alfaro logró clasificar a la etapa final, que se realizará en Santiago.

Catalina nos representará los días jueves 22 y viernes 23 de octubre, con la premiación el sábado 24. Su clasificación es fruto de dedicación, esfuerzo personal y del acompañamiento de sus profesores y su familia, y refleja el compromiso que sostiene el trabajo académico de nuestro colegio.

Como comunidad educativa, nos sentimos orgullosos de este logro. Participar en una instancia de esta exigencia es una gran oportunidad para demostrar lo aprendido y para proyectar el talento matemático de nuestros estudiantes más allá de las aulas.

¡Vamos Catalina, todo el colegio está contigo!`,
      image: "/03-news/olimpiadas-matematica-catalina-velasquez.webp",
      isNew: true
    },
    {
      id: 14,
      title: "Antología \"La Voz de los 20\"",
      date: "2026-10-14",
      content: `Felicitamos especialmente a Fernando Huenchupan, de 8° Básico Alfa, y Sophía Bustos, de 1° Medio Omega, quienes fueron seleccionados para formar parte de la publicación de la antología de poesía "La Voz de los 20", iniciativa patrocinada por la Sociedad de Escritores de Chile, sede Quinta Región.

Esta instancia representa una valiosa oportunidad para fomentar la expresión literaria, reconocer el talento y la creatividad de nuestros estudiantes y motivarlos a continuar desarrollándose como jóvenes escritores, llevando con orgullo el nombre de nuestra comunidad educativa a nuevos espacios culturales y literarios.

La ceremonia de presentación y reconocimiento se llevará a cabo el miércoles 28 de octubre en el Hotel O'Higgins.`,
      image: "/03-news/antologia-la-voz-de-los-20.webp",
      isNew: true
    },
    {
      id: 15,
      title: "Coro de Cámara Nuevo Milenio",
      date: "2026-10-14",
      content: `Formado por alumnos de 7° Básico a 4° Medio, con un total de 25 integrantes y 24 años de trayectoria musical, el Coro Nuevo Milenio ha participado en diversas actividades, tanto a nivel competitivo como en encuentros corales.

Una de ellas es el concurso nacional de coros "Crecer cantando", organizado por el Teatro Municipal de Santiago, donde pasó a la segunda etapa de este certamen, que se realizará el miércoles 21 de octubre en el Colegio María Luisa Villalón, en Santiago.

Su repertorio abarca desde lo docto a lo popular, incluyendo el rock, y trabaja la armonización vocal a cuatro voces mixtas. Los integrantes están dirigidos por su directora y profesora de música, Johanna Medina Miranda.`,
      image: "/03-news/coro-de-camara.webp",
      isNew: true
    },
    {
      id: 16,
      title: "ABP 7° Básico Omega",
      date: "2026-10-14",
      content: `El 7° Básico Omega desarrolló una experiencia de Aprendizaje Basado en Proyectos (ABP) en torno a la investigación "La importancia del apoyo de padres, madres y cuidadores, en el desarrollo integral de niños y niñas".

A través de la investigación, la reflexión, la escritura y el trabajo colaborativo, los estudiantes pudieron expresar sus aprendizajes y valorar la importancia de los vínculos y del acompañamiento en el desarrollo integral.

Este trabajo será presentado en el VI Encuentro Interescolar de Estudiantes, organizado por el Departamento Provincial de Educación en el marco de la Red de Lenguaje y Líderes en Educación, que se realizará el jueves 22 de octubre en el Liceo Guillermo Rivera. Allí, el curso tendrá la oportunidad de compartir su experiencia y creación con otros estudiantes y comunidades educativas.

Próximamente se realizará la presentación de la antología a nuestra comunidad escolar, como cierre y celebración de este significativo proceso de aprendizaje y creación colectiva.`,
      image: "/03-news/abp-7-basico-omega.webp",
      isNew: true
    },
    {
      id: 17,
      title: "¡Campeonas invictas! El talento femenino brilla en Villa Alemana",
      date: "2026-10-14",
      content: `Con inmenso orgullo celebramos el triunfo de nuestras talentosas alumnas en las "Olimpiadas Deportivas de Villa Alemana 2026", en la categoría Sub 13 de Futbolito Femenino. Con garra, corazón y un juego impecable, nuestras guerreras se coronaron campeonas, alzándose con el merecidísimo primer lugar.

Este logro histórico no solo demuestra su destreza técnica y estratégica en la cancha, sino también su dedicación inquebrantable, su espíritu de equipo y su pasión por el deporte. Desde el primer pitazo hasta el último gol, cada jugadora entregó lo mejor de sí, inspirándonos a todos con su determinación y alegría por jugar.

Queremos invitar a toda nuestra comunidad escolar a unirse a esta celebración. Marquen sus calendarios: la ceremonia oficial de premiación, donde recibirán sus medallas y el trofeo que las consagra como las mejores de Villa Alemana, se llevará a cabo en el mes de noviembre de 2026.

¡Su victoria es nuestra victoria, y su ejemplo nos motiva a seguir cultivando el talento y el espíritu deportivo en cada una de nuestras estudiantes! ¡Felicitaciones a todo el equipo, cuerpo técnico y familias que las apoyaron incondicionalmente!`,
      image: "/03-news/futbolito-femenino-sub-13-campeonas.webp",
      isNew: true
    },
    {
      id: 18,
      title: "¡Victoria en la cancha! Equipo de voleibol Sub 15 triunfa en su segundo encuentro de las Olimpiadas de Villa Alemana",
      date: "2026-10-14",
      content: `Celebración en alto para nuestra selección de Voleibol Femenino Categoría Sub 15, que se quedó con una brillante victoria en su segundo encuentro en las Olimpiadas Deportivas de Villa Alemana.

En un partido vibrante de principio a fin, las estudiantes mostraron una excelente coordinación, saques certeros y un trabajo en equipo impecable en cada punto disputado. Su concentración, temple y espíritu deportivo les permitieron consolidar el juego y asegurar este importante triunfo que nos llena de orgullo a todos.

Enviamos un afectuoso reconocimiento a cada una de nuestras jugadoras por su entrega en la cancha, así como a su cuerpo técnico y a las familias que estuvieron alentando incondicionalmente desde la tribuna.`,
      image: "/03-news/voleibol-sub-15.webp",
      isNew: true
    },
    {
      id: 19,
      title: "¡Gran espíritu de superación! Nuestro equipo Sub 13 de futbolito masculino destaca en las Olimpiadas de Villa Alemana",
      date: "2026-10-14",
      content: `Queremos felicitar con gran orgullo a nuestro equipo de Futbolito Masculino Categoría Sub 13, que tuvo una destacada y emocionante participación en las Olimpiadas Deportivas de Villa Alemana. Nuestros estudiantes demostraron un tremendo crecimiento y garra deportiva, superando todos sus resultados del año anterior y alcanzando una merecida clasificación a los cuartos de final.

La definición de la etapa fue un auténtico espectáculo de alta intensidad y emociones a flor de piel. Tras un disputado y parejo partido, la llave terminó definiéndose en la tanda de penales, donde la suerte no estuvo de nuestro lado. Sin embargo, el coraje, la entrega y la pasión demostrada en la cancha nos dejan un sabor de victoria y la certeza de que el camino recorrido ha sido extraordinario.

Agradecemos profundamente a cada uno de los jugadores por defender nuestra camiseta con honor, respeto y trabajo en equipo, así como a sus entrenadores y familias por el constante apoyo. ¡Felicitaciones muchachos por este hito! Seguimos avanzando y creciendo juntos. ¡A preparar con todo los próximos desafíos!`,
      image: "/03-news/futbolito-masculino-sub-13.webp",
      isNew: true
    },
    {
      id: 20,
      title: "Orgullo y perseverancia en las Olimpiadas Deportivas de Villa Alemana",
      date: "2026-10-14",
      content: `Queremos felicitar cordialmente a nuestra categoría Sub 11 de Futbolito Masculino, que representó a nuestro establecimiento en las Olimpiadas Deportivas de Villa Alemana.

Destacamos un importante avance en el proceso formativo de los estudiantes, quienes sumaron una valiosa experiencia en realidad de juego dentro de la cancha. Más allá de cualquier resultado, los alumnos demostraron una perseverancia ejemplar: jamás se rindieron y lucharon con convicción y entusiasmo en cada jugada.

A lo largo del torneo, el equipo dejó en alto la identidad de nuestro colegio, reflejando día a día los sellos institucionales que nos caracterizan:

- Respeto: manteniendo una conducta ejemplar con los rivales, árbitros y compañeros.
- Solidaridad: apoyándose mutuamente dentro y fuera del terreno de juego.
- Empatía: comprendiendo y valorando el esfuerzo de cada integrante del equipo.

Agradecemos a los entrenadores, profesores y familias por su constante apoyo en este camino de aprendizaje y crecimiento. ¡Felicitaciones a nuestros jóvenes deportistas por su compromiso, actitud y espíritu de superación!`,
      image: "/03-news/futbolito-masculino-sub-11.webp",
      isNew: true
    },
    {
      id: 21,
      title: "¡Gran debut en baloncesto! Destacada participación de nuestra categoría U-11 en las Olimpiadas de Villa Alemana",
      date: "2026-10-14",
      content: `Con entusiasmo, energía y mucho trabajo en equipo, nuestra selección de Básquetbol Categoría U-11 tuvo su emocionante primer encuentro en el marco de las Olimpiadas Deportivas de Villa Alemana.

En este debut, las jugadoras saltaron a la cancha demostrando un tremendo compromiso, compañerismo y ganas de seguir aprendiendo. Cada cuarto del partido reflejó el esfuerzo y la preparación que han venido realizando, viviendo una valiosa experiencia competitiva que fortalece su desarrollo deportivo y personal.

Felicitamos a nuestras deportistas, a su entrenadora y a las familias que desde la tribuna brindaron su constante apoyo. ¡Este primer paso marca el inicio de un gran camino de crecimiento para el básquetbol de nuestro colegio!`,
      image: "/03-news/basquetbol-u-11-debut.webp",
      isNew: true
    },
    {
      id: 22,
      title: "¡Paso firme en la cancha! Excelente debut de nuestra categoría U-13 de básquetbol en las Olimpiadas de Villa Alemana",
      date: "2026-10-14",
      content: `Nuestra selección de Básquetbol Categoría U-13 saltó a la cancha para disputar su primer encuentro en las Olimpiadas Deportivas de Villa Alemana.

En este esperado debut, las jugadoras demostraron una notable madurez deportiva, garra y un sólido juego colectivo en cada minuto del partido. Su entrega en la defensa, la fluidez en el ataque y el apoyo constante entre compañeras reflejan el arduo trabajo de preparación y la pasión que sienten por esta disciplina.

Extendemos un cariñoso reconocimiento a nuestras deportistas, a su entrenadora y a cada una de las familias que las acompañaron con entusiasmo desde la tribuna.

¡Este primer partido es solo el comienzo de un gran torneo para nuestro equipo!`,
      image: "/03-news/basquetbol-u-13-debut.webp",
      isNew: true
    },
    {
      id: 3,
      title: "Nuevas Listas de Útiles Escolares 2026",
      date: "2026-01-15",
      content: `Estimadas familias del Colegio Nuevo Milenio,  
Les informamos que ya se encuentran disponibles las nuevas listas de útiles escolares para el año 2026. Pueden descargarlas desde la sección "Lista de Útiles" de nuestra página web.

Las listas están disponibles para todos los niveles, desde Pre Kinder hasta 4° Medio.`,
      content2: "",
      image: "",
      isNew: true
    },
    {
      id: 1,
      title: "Cierre de Oficinas de Administración - Vacaciones de Verano",
      date: "2025-12-31",
      content: `Estimadas familias del Colegio Nuevo Milenio,  
Les informamos que las oficinas de administración estarán cerradas por vacaciones de verano desde el día martes 30 de diciembre y volveremos el lunes 23 de febrero.`,
      content2: "",
      image: "",
      isNew: true
    },
    {
      id: 2,
      title: "Nuevos numeros de contacto",
      date: "2025-03-31",
      content: `Estimadas familias del Colegio Nuevo Milenio,  
Les informamos que hay nuevos numeros telefónicos para comunicarse con nosotros:

- Secretaría: 56 9 9997 3396
- Recaudación: 56 9 8723 9659
- Recepción: 56 9 8723 7809 
- Inspectoría: 56 9 9997 3482`,
      image: "/03-news/numeros.webp",
      isNew: false
    },
  ];
  
  export default newsContent;